import { Flex, Select } from "@mantine/core";

import type { IVRHandoffFormType } from "@/customer-panel/components/call-intro-flow/steps/customer-info/types";

export function SalesQuestionnaire({ form, plans }: { form: IVRHandoffFormType; plans: string[] }) {
    return (
        <Flex h="100%" mt="xl" direction="column">
            <Select
                onChange={(val) => {
                    form.setValues({
                        currentPlan: val,
                    });
                }}
                label="Plan name"
                allowDeselect={false}
                mt="xl"
                placeholder="Choose a plan"
                data={plans}
                key={form.key("currentPlan")}
            />
        </Flex>
    );
}
